import { Button, Flex, Image, Row, styled, useTheme } from '@teko/ds-desktop';
import { PenColored } from '@teko/ds-icon';
import { ISupermarketTerminal } from '@teko/order';
import { Spinner } from 'components/desktop/atoms';
import {
  MODE_TERMINAL_PICKER,
  useDistanceTerminalContext,
  useTenantConfig,
} from 'contexts';
import { t } from 'i18n';
import { TerminalPickerItem } from 'modules/terminal/desktop/TerminalPickerItem';
import { useEffect, useState } from 'react';
import TerminalPicker from '../../../../assets/terminal-picker.png';
import { HeaderModal } from './HeaderModal';

export const ModeListTerminal = ({
  onClosePopup,
}: {
  onClosePopup: () => void;
}) => {
  const {
    setNewTerminal,
    isLoadingGetDistanceTerminals,
    setModeTerminalPicker,
    isModeEnterAddress,
    isGetCurrentLocation,
    temporaryDataDistanceTerminal,
    currentTerminals = [],
    currentTerminal,
    modeTerminalPicker,
    setMessageError,
  } = useDistanceTerminalContext();
  const { colors } = useTheme();
  const [terminal, setTerminal] = useState<ISupermarketTerminal | undefined>(
    undefined,
  );
  const { epicOmni1589 } = useTenantConfig();
  const { location: locationGetDistanceTerminals } =
    temporaryDataDistanceTerminal;

  useEffect(() => {
    if (
      !!currentTerminals &&
      Array.isArray(currentTerminals) &&
      !!currentTerminals.length &&
      modeTerminalPicker === MODE_TERMINAL_PICKER.LIST_TERMINAL
    ) {
      setTerminal?.(
        !!currentTerminal
          ? currentTerminals.find(
              (t) => t.terminalId === currentTerminal.terminalId,
            ) || currentTerminals?.[0]
          : currentTerminals?.[0],
      );
    }
  }, [
    currentTerminal,
    currentTerminals,
    isModeEnterAddress,
    modeTerminalPicker,
  ]);

  if (isLoadingGetDistanceTerminals) {
    return (
      <Wrapper
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spinner />
      </Wrapper>
    );
  }

  const onUpdateAddress = () => {
    setModeTerminalPicker?.(MODE_TERMINAL_PICKER.LIST_ADDRESS);
    setMessageError?.('');
  };

  return (
    <>
      <HeaderModal
        displayBackButton={false}
        onClosePopup={onClosePopup}
        title={t('Chọn khu vực của bạn')}
        subTitle={t('Để biết chính xác tồn kho và thời gian giao hàng')}
      />
      <div style={{ marginBottom: 16, marginTop: 16, textAlign: 'center' }}>
        <Image src={TerminalPicker} width={120} height={74} />
      </div>
      <Header justify="space-between">
        {isGetCurrentLocation ? (
          <Title style={{ width: '75%' }}>
            {t('Đang sử dụng vị trí hiện tại của bạn')}
          </Title>
        ) : (
          <Title style={{ width: '75%', fontWeight: 'bold' }}>
            {t('Địa chỉ')}:
          </Title>
        )}

        <Row onClick={onUpdateAddress} style={{ cursor: 'pointer' }}>
          <PenColored size={16} />
          <Title
            style={{
              fontWeight: 'initial',
              color: colors.primary,
              marginLeft: 8,
            }}
          >
            {t('Thay đổi')}
          </Title>
        </Row>
      </Header>
      <Flex direction="column">
        <Title>
          {locationGetDistanceTerminals?.address},{' '}
          {locationGetDistanceTerminals?.wardName},{' '}
          {!epicOmni1589
            ? `${locationGetDistanceTerminals?.districtName}, `
            : ''}
          {locationGetDistanceTerminals?.provinceName}
        </Title>
        <Title style={{ marginTop: 16 }}>
          {temporaryDataDistanceTerminal?.terminals?.length}{' '}
          {t('siêu thị gần bạn')}:
        </Title>
      </Flex>
      <Wrapper>
        {temporaryDataDistanceTerminal?.terminals?.map((item) => {
          return (
            <TerminalPickerItem
              key={item.terminalId}
              onClick={() => setTerminal(item)}
              isChoice={terminal?.terminalId === item.terminalId}
              terminalName={item.terminalName}
              distance={item.distance}
              terminalAddress={item.fullAddress}
            />
          );
        })}
      </Wrapper>
      <Button
        block
        onClick={() => {
          if (!!terminal) {
            setNewTerminal?.(terminal);
          }
        }}
        variant="primary"
        disabled={!terminal || isLoadingGetDistanceTerminals}
      >
        {t('Mua sắm ngay')}
      </Button>
    </>
  );
};

const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const Wrapper = styled.div`
  height: 30vh;
  overflow: auto;
  margin-bottom: 16px;
`;

const Header = styled(Row)`
  width: 100%;
`;
